import { FileImageOutlined } from '@easyv/react-icons';
import { AssetBase } from './AssetBase';
import React from 'react';
import { AssetItem } from '@/type';
import { Space } from '@easyv/react-components';
import { ProButton } from '@/UIGenerator/uicomponents/ProButton';

interface ImageProps {
  data: AssetItem<'image'>;
  onSelected: (item: AssetItem) => void;
}

export function Image({ data, onSelected }: ImageProps) {
  return (
    <AssetBase
      data={data}
      defaultThumb={'@/assets/img/model.png'}
      icon={<FileImageOutlined size={16} />}
      hoverRender={
        <Space direction='vertical' align='center'>
          <ProButton
            size='small'
            type='primary'
            className='w-14 h-6 leading-4 p-0'
            onClick={(e) => {
              e.preventDefault();
              onSelected(data);
            }}
          >
            上传
          </ProButton>
        </Space>
      }
    />
  );
}
